import React, { useEffect, useState } from "react";
import { Button } from "../ui/button";
import { Info } from "lucide-react";

interface VerifyCustomerModalProps {
    isOpen: boolean;
    onClose: () => void;
    onVerify: (code: string) => void;
    isVerifying: boolean;
}

const VerifyCustomerModal: React.FC<VerifyCustomerModalProps> = ({
                                                                     isOpen,
                                                                     onClose,
                                                                     onVerify,
                                                                     isVerifying,
                                                                 }) => {
    const [code, setCode] = useState("");
    const [error, setError] = useState("");

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        if (code.length !== 6 || isNaN(Number(code))) {
            setError("Please enter a valid 6-digit code.");
            return;
        }
        setError("");
        onVerify(code);
        setCode(""); // Optionally reset after verify
    };

    useEffect(() => {
        if (!isOpen) {
            setCode("");
            setError("");
        }
    }, [isOpen]);

    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40 backdrop-blur">
            <div className="bg-white dark:bg-gray-800 rounded-2xl shadow-2xl w-full max-w-xs p-7 relative">
                {/* Instruction */}
                <div className="mb-5 flex flex-col items-center text-center gap-2">

                    <p className="text-gray-600 dark:text-gray-300 text-xs font-medium">
                        For every SurpriseTable booking, the customer receives a unique 6-digit code.<br />
                        <span className="font-semibold text-green-700">
                            Always ask the customer for this code upon arrival.
                        </span><br />

                    </p>
                </div>
                <h2 className="text-lg font-semibold mb-2 text-gray-800 dark:text-gray-100 text-center">
                    Customer Code Verification
                </h2>
                <form onSubmit={handleSubmit}>
                    <input
                        type="text"
                        inputMode="numeric"
                        pattern="[0-9]*"
                        placeholder="Enter 6-digit code"
                        maxLength={6}
                        className="w-full border border-green-500 rounded-lg px-4 py-3 mb-3 text-black text-xl font-mono tracking-widest text-center focus:outline-none focus:ring focus:ring-green-600"
                        value={code}
                        onChange={(e) =>
                            setCode(e.target.value.replace(/\D/g, "").slice(0, 6))
                        }
                        autoFocus
                    />
                    {error && (
                        <p className="text-red-500 text-xs mb-2 text-center">{error}</p>
                    )}
                    <div className="flex justify-end gap-2 mt-2">
                        <Button variant="outline" type="button" onClick={onClose}>
                            Cancel
                        </Button>
                        <Button
                            type="submit"
                            className="bg-green-600 hover:bg-green-700 text-white"
                            disabled={isVerifying}
                        >
                            {isVerifying ? "Verifying..." : "Submit"}
                        </Button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default VerifyCustomerModal;
